import { actionTypes } from './pageInfo.actions';

const initialState = {
    isPhone: false,
    isTablet: false,
    isBookmakerSwitcherOpened: false,
};

export default function pageReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SET_DEVICE_TYPE:
            return {
                ...state,
                isPhone: action.isPhone,
                isTablet: action.isTablet,
            };
        case actionTypes.SET_API_URL:
            return {
                ...state,
                apiUrl: action.apiUrl,
                apiV2Url: action.apiV2Url,
                apiV3Url: action.apiV3Url,
            };
        case actionTypes.USE_DECIMAL_ODDS:
            return {
                ...state,
                useDecimalOdds: action.useDecimalOdds,
            };
        case actionTypes.OPEN_BOOKMAKER_SWITCHER_POPOVER:
            return {
                ...state,
                isBookmakerSwitcherOpened: true,
            };
        case actionTypes.CLOSE_BOOKMAKER_SWITCHER_POPOVER:
            return {
                ...state,
                isBookmakerSwitcherOpened: false,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /src/js/common/pageInfo/pageInfo.reducer.js